'use client';
import ArrowLeft from '@/app/_components/ui/icons/ArrowLeft.svg';
import React from 'react';
import Link from 'next/link';
import moment from 'jalali-moment';
import PriceUnit from '@/app/_components/share/PriceUnit';
import { statuses } from '@/app/_libs/utils/constants/orderStatuses';

export default function OrderRow({ order }) {
  const status = (statusKey) => {
    if (statuses[statusKey]) {
      return statuses[statusKey];
    }
    return 'Status not found';
  };

  return (
    <tr className="bg-white border-b border-light-gray ">
      <td className="px-4 py-4 text-sm whitespace-nowrap">
        <span
          className={`order-status ${
            status(order.status).class
          } text-light-green-300 bg-light-green-100 py-1.5 px-3  inline-block text-center rounded-md`}
        >
          {status(order.status).title}
        </span>
      </td>
      <td className="px-4 py-4 text-sm">{order.id} </td>
      <td className="px-4 py-4 min-w-[100px]  text-sm">
        {moment(order.created_at, 'YYYY-MM-DD')
          .locale('fa')
          .format('YYYY-MM-DD')}
      </td>
      <td className="px-4 py-4  text-sm">
        <div className="flex">
          <PriceUnit
            price={
              order?.factor?.profit
                ? order?.factor?.amount + order?.factor?.profit
                : order?.factor?.amount
            }
          />
        </div>
      </td>
      <td className="px-4 py-4  text-sm">
        <div className="flex">
          <PriceUnit price={order?.factor?.amount} />
        </div>
      </td>
      <td className="px-4 py-4 text-right relative flex  text-sm">
        <div className="px-2 text-ocean-blue  font-bold">
          <Link
            href={`/profile/orders/${order.id}`}
            className="flex items-center"
          >
            <span className="pl-1">جزییات</span>
            <ArrowLeft fill="#2A75BB" />
          </Link>
        </div>
      </td>
    </tr>
  );
}
